import Swiper from 'swiper';
import { EffectFade, Pagination, Thumbs } from 'swiper/modules';

export function productGallery() {
  const thumbnailSwiper = new Swiper('.product__thumbnail-swiper', {
    slidesPerView: '3',
    spaceBetween: 16,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'vertical',
    breakpoints: {},
  });

  new Swiper('.product-gallery__swiper', {
    modules: [Pagination, EffectFade, Thumbs],
    loop: true,
    effect: 'fade',
    spaceBetween: 20,
    thumbs: {
      swiper: thumbnailSwiper,
    },
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
